import React, { useState, useEffect } from "react";
import { useTransition, animated } from "react-spring";
import ProgressBar from "../../ProgressBar";
import { stepStyles } from "../formStyles";

export const WhereAreYouLooking = ({ formData, setForm, navigation }) => {
  const { city, state } = formData;
  const [stateArray, setStateArray] = useState([]);
  const [cityError, setCityError] = useState(false);
  const [stateError, setStateError] = useState(false);

  const [isVisible] = useState(true);
  const [toolTip, setToolTip] = useState(false);

  const transition = useTransition(isVisible, {
    from: { opacity: 0, transform: "translate3d(500px,0px,0)" },
    enter: { opacity: 1, transform: "translate3d(0,0px,0)" },
  });

  useEffect(() => {
    getStatesList();
    async function getStatesList() {
      // graphql query string to get list of states
      const statesListQuery = `{
      statesList {
        abbreviation
        name
      }
    }`;

      const res = await fetch("https://graphql-onetrust.herokuapp.com/", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ query: statesListQuery }),
      });

      const statesList = await res.json();
      setStateArray(statesList.data.statesList);
      return statesList;
    }
  }, []);
  console.log(stateArray);

  const checkForNextStep = () => {
    if (formData.city === "") {
      setCityError(true);
      console.log("error");
    }
    if (formData.state === "") {
      setStateError(true);
      console.log("error");
    }

    if (formData.state !== "" && formData.city !== "") {
      navigation.next();
      console.log("next");
    }
  };

  return (
    <div className={stepStyles.page}>
      <ProgressBar width={"10%"} />
      <div className={stepStyles.content}>
        {transition((style, item) =>
          item ? (
            <animated.div style={style} className={stepStyles.panel}>
              <h1 className={stepStyles.title}>Where are you looking to buy a home?</h1>
              <div className="mt-6 flex w-full max-w-xl flex-col gap-6 text-left">
                <div className="w-full">
                  <label
                    htmlFor="city"
                    className="mb-2 block text-sm font-semibold uppercase tracking-[0.14em] text-gray-satan"
                  >
                    City
                  </label>
                  <div className="w-full">
                    <input
                      name="city"
                      value={city}
                      onChange={setForm}
                      id="city"
                      className={stepStyles.input}
                      placeholder="City"
                    />
                  </div>
                  {cityError ? (
                    <p className="mt-3 text-sm font-semibold text-red-error">please fill out an answer</p>
                  ) : null}
                </div>
                <div className="relative w-full">
                  <div className="mb-2 flex items-center gap-3">
                    <label
                      htmlFor="state"
                      className="text-sm font-semibold uppercase tracking-[0.14em] text-gray-satan"
                    >
                      State
                    </label>
                    <div
                      className="relative inline-flex"
                      onMouseEnter={() => setToolTip(true)}
                      onMouseLeave={() => setToolTip(false)}
                    >
                      <div className={`${stepStyles.tooltipTrigger} ml-0 h-8 w-8 text-base`}>?</div>
                      {toolTip ? (
                        <div className="absolute left-0 top-11 z-50 w-72 rounded-3xl border border-blue-primary/10 bg-blue-primary p-4 text-left shadow-panel md:left-1/2 md:top-1/2 md:ml-4 md:-translate-y-1/2">
                          <p className="p-0 text-sm text-white">
                            We are able to provide home financing solutions to clients in the states in which we are
                            licensed as Warp Speed Mortgage. Please see our{" "}
                            <a
                              target="_blank"
                              rel="noreferrer"
                              className="font-semibold text-green-primary underline"
                              href="https://warpspeedmortgage.com/licensing/"
                            >
                              Locations & Licensing
                            </a>{" "}
                            page for more details.
                          </p>
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <div className="w-full">
                    <select name="state" value={state} onChange={setForm} id="state" className={stepStyles.select}>
                      <option value="">Select a State</option>
                      {stateArray.map((state) => (
                        <option key={state.abbreviation} value={state.abbreviation}>
                          {state.name}
                        </option>
                      ))}
                    </select>
                  </div>
                  {stateError ? (
                    <p className="mt-3 text-sm font-semibold text-red-error">please fill out an answer</p>
                  ) : null}
                </div>
              </div>
            </animated.div>
          ) : null,
        )}
      </div>

      <div className={stepStyles.actionBar}>
        <div className={stepStyles.actionRow}>
          <div className="w-full md:w-auto">
            <button className={`${stepStyles.button} w-full`} onClick={() => checkForNextStep()}>
              Next
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
